import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
const colorOptions = [
    '#FFFFFF',
    '#000000',
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#FF33A1',
    '#A133FF',
    '#33FFF5',
    '#F5FF33',
    '#FF8C33',
    '#8C33FF',
    '#33FF8C',
    '#FF3333',
    '#3333FF',
    '#custom',
];
const ColorPalette = ({ selectedColor, onColorChange, }) => {
    const [color, setColor] = useState(selectedColor);
    const isCustom = !colorOptions.includes(color);
    const colorChanged = (newColor) => {
        setColor(newColor);
        onColorChange(newColor);
    };
    return (_jsx("div", { style: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'flex-start',
        }, children: colorOptions.map((colorOption, index) => (_jsx("div", { children: colorOption === '#custom' ? (_jsx("div", { style: {
                    position: 'relative',
                    margin: '10px',
                    width: '30px',
                    height: '30px',
                    cursor: 'pointer',
                    borderRadius: '50%',
                    border: isCustom ? '2px solid black' : 'none',
                    background: 'linear-gradient(45deg, #FF5733, #33FF57)',
                }, children: _jsx("input", { type: "color", className: "input-color-type", onChange: (e) => colorChanged(e.target.value), style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: 0,
                        cursor: 'pointer',
                        borderRadius: '50%',
                    } }) })) : (_jsx("div", { onClick: () => colorChanged(colorOption), style: {
                    backgroundColor: colorOption,
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    margin: '3px',
                    cursor: 'pointer',
                    border: color !== colorOption ? '1px solid #ccc' : '2px solid black',
                } })) }, index))) }));
};
export default ColorPalette;
